import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { PopUpContainer } from "assets/css/globle";
import { useTranslation } from "react-i18next";

const HoleAreaAlreadyExistsPopup = ({
  openAlertModal,
  setOpenAlertModal,
  closeDeleteModal,
}) => {
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 444,
    bgcolor: "background.paper",
    // boxShadow: 24,
    width: "100%",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "4px",
    outline: "none",
  };

  const { t } = useTranslation();

  return (
    <Modal
      open={openAlertModal}
      onClose={() => {
        setOpenAlertModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      maxWidth="sm"
      sx={{ zIndex: 10001 }}
    >
      <Box sx={style1}>
        <PopUpContainer>
          <div style={{ margin: 20 }}>
            This type of hole area already exists for this hole. Please select a
            different area type to save.
          </div>

          <div className="action-btn">
            <button
              onClick={() => {
                setOpenAlertModal(false);
              }}
            >
              {t("Ok")}
            </button>
          </div>
        </PopUpContainer>
      </Box>
    </Modal>
  );
};

export default HoleAreaAlreadyExistsPopup;
